import React from "react";
import PropTypes from "prop-types";
import { Checkbox, FormControlLabel, TextField } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import withIntl from "../../utils/withIntl";
import Button from "@material-ui/core/Button";

function CustomTextField(props) {
  return (
    <>
      <Grid item xs={2}>
        <p>{props.intl.formatMessage({ id: "Text" })}</p>
      </Grid>
      <Grid item xs={4}>
        <TextField
          margin={"dense"}
          onChange={(e) => {
            props.onChange({ ...props.customField, label: e.target.value });
          }}
          type={"text"}
          placeholder={props.intl.formatMessage({ id: "Label" })}
          value={props.customField.label}
        />
      </Grid>
      <Grid item xs={2}>
        <FormControlLabel
          style={{ marginLeft: 0 }}
          labelPlacement={"top"}
          control={
            <Checkbox
              margin={"dense"}
              onChange={(e) => {
                props.onChange({ ...props.customField, required: e.target.checked });
              }}
              checked={props.customField.required}
            />
          }
          label={"Required"}
        />
      </Grid>
      <Grid item xs={4}>
        <Button
          variant={"outlined"}
          onClick={() => {
            props.onRemove();
          }}
        >
          Remove
        </Button>
      </Grid>
      <Grid item xs={12}>
        <TextField
          margin={"dense"}
          onChange={(e) => {
            props.onChange({ ...props.customField, min_length: e.target.value });
          }}
          type={"number"}
          label={props.intl.formatMessage({ id: "Min length" })}
          value={props.customField.min_length ?? (props.customField.required ? 1 : 0)}
        />
      </Grid>
    </>
  );
}

CustomTextField.propTypes = {
  customField: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withIntl(CustomTextField);
